import style from "./About.module.css";

export default function VyraAbout() {
  return (
    <div className="about">
      <section className={style.aboutHero}>
        <div className="container">
          <h2>About</h2>
          <h1>Vyra Pharma</h1>
          <p>
            Committed to Quality Healthcare and Innovative Pharmaceutical
            Solutions
          </p>
        </div>
      </section>

      <section className={style.aboutContent}>
        <div className="container">
          <div className={style.aboutGrid}>
            <div className={style.aboutText}>
              <h2>Who We Are</h2>
              <p>
                Vyra Pharma is a pharmaceutical company focused on delivering
                high-quality, safe, and effective healthcare products. We
                specialize in marketing pharmaceutical formulations including
                tablets, capsules, syrups, injections, and nutraceuticals.
              </p>

              <p>
                Our commitment is to improve patient outcomes by combining
                innovation, strict quality standards, and affordability. We work
                with healthcare professionals to provide trusted medicines
                across multiple therapeutic segments.
              </p>

              <div className={style.valuesList}>
                <div className={style.valueItem}>
                  <span className="value-icon">🎯</span>
                  <div>
                    <h4>Quality First</h4>
                    <p>
                      Uncompromising quality in every product we manufacture
                    </p>
                  </div>
                </div>
                <div className={style.valueItem}>
                  <span className="value-icon">🔬</span>
                  <div>
                    <h4>Innovation Driven</h4>
                    <p>
                      Continuous research and development for better healthcare
                    </p>
                  </div>
                </div>
                <div className={style.valueItem}>
                  <span className="value-icon">🤝</span>
                  <div>
                    <h4>Patient Centric</h4>
                    <p>Affordable solutions accessible to all communities</p>
                  </div>
                </div>
              </div>
            </div>

            <div className={style.aboutStats}>
              <div className="stat">
                <h3>19+</h3>
                <p>Products</p>
              </div>

              <div className="stat">
                <h3>10+</h3>
                <p>Distributors</p>
              </div>

              <div className="stat">
                <h3>10+</h3>
                <p>Therapy Areas</p>
              </div>

              <div className="stat">
                <h3>WHO-GMP</h3>
                <p>Certified</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={style.aboutTeam}>
        <div className="container">
          <h2>Our Mission</h2>
          <p className="mission-text">
            To provide high-quality pharmaceutical products that enhance patient
            care while maintaining affordability, innovation, and global quality
            standards.
          </p>

          <h2>Our Vision</h2>
          <p>
            To become a trusted pharmaceutical brand known for excellence,
            reliability, and commitment to healthcare professionals and
            patients.
          </p>
        </div>
      </section>
    </div>
  );
}
